import {
    Stack,
    Typography,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import searchIcon from "../assets/images/icons/searchIcon.svg";
import { CustomSearchInput } from "../utils/constant";
import useDebounce from "../hooks/use.debounce";
import { useNavigate } from "react-router-dom";
import AvatarComponent from "../components/avatar";
import CustomTable from "../components/customTable";
import CustomizedSnackbars from "../components/snackbar";
import {
    useGetRequestedInfluencersQuery,
    useUpdateInflyxRequestStatusMutation
} from "../redux/api";
import { ROUTES } from "../utils/routes";

const RequestedInflyxCoins = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 500);

    const { data, isLoading, refetch } = useGetRequestedInfluencersQuery({
        limit,
        offset: page * limit,
        search: debouncedSearch
    });

    const [updateStatus, { isLoading: isStatusUpdating }] = useUpdateInflyxRequestStatusMutation();

    const [snackbar, setSnackbar] = React.useState({
        message: "",
        severity: "success",
        open: false,
    });

    const [confirmAction, setConfirmAction] = useState(null);

    const handleConfirmClose = () => {
        setConfirmAction(null);
    };

    const handleConfirmProceed = () => {
        if (confirmAction) {
            handleStatusUpdate(confirmAction.id, confirmAction.status);
            setConfirmAction(null);
        }
    };

    const handleStatusUpdate = async (id, newStatus) => {
        try {
            await updateStatus({
                influencerId: id,
                status: newStatus
            }).unwrap();

            setSnackbar({
                message: `Request ${newStatus} successfully`,
                severity: "success",
                open: true
            });
            refetch();
        } catch (error) {
            console.error("Status update failed", error);
            setSnackbar({
                message: "Failed to update status",
                severity: "error",
                open: true
            });
        }
    };

    const Action = (row) => {
        const { id } = row;
        return (
            <div className="actBtnGrps">
                <span className="viewIcon" onClick={() => navigate(`${ROUTES.REQUESTED_INFLYX_COINS}/details/${id}`)}>View</span>
                <span className="editIcon" onClick={() => setConfirmAction({ id, status: 'Approved' })}>Accept</span>
                <span className="deleteIcon" onClick={() => setConfirmAction({ id, status: 'Rejected' })}>Reject</span>
            </div>
        );
    };

    const cols = [
        "photo",
        "name",
        "inflyxScore",
        "inflyxCoin",
    ];

    const tableData = [];
    if (data?.result?.list?.length) {
        for (const key of data.result.list) {
            tableData.push({
                photo: <AvatarComponent image={key.picture} />,
                name: key.name,
                id: key.influencerId,
                inflyxScore: key.inflyxScore !== null && key.inflyxScore !== undefined ? key.inflyxScore : "N/A",
                inflyxCoin: key.inflyxCoin,
            });
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(0);
    }

    const handleClearSearch = () => {
        setSearch("");
        setPage(0);
    }

    return (
        <>
            <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} style={{ maxWidth: '100%' }} />
            <Stack direction={"column"} gap={2}>
                <Stack
                    className="mainTitle  flex-wrap"
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px',
                        padding: '0px 16px',
                    }}
                >
                    <Typography className="page-title" variant="h1">
                        Requested Inflyx Coins
                    </Typography>
                    <Stack direction={"row"} gap={2}>
                        <CustomSearchInput
                            className="inputSearch sContrl p-0"
                            value={search}
                            placeholder={"Search here..."}
                            handleSearch={handleSearch}
                            clearSearch={handleClearSearch}
                            startAdornment={
                                <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                                    sx={{
                                        maxHeight: 'none',
                                        height: '38px',
                                        minWidth: '38px',
                                        marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                                    }}
                                >
                                    <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                                </InputAdornment>
                            }
                        />
                    </Stack>
                </Stack>
                <Box sx={{ padding: '0px 16px' }}>

                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            transition: 'all .5s ease-in-out',
                            position: 'relative',
                            border: '1px solid rgba(170, 170, 170, 0.3)',
                            borderRadius: '12px',
                            boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                            overflow: 'hidden',
                        }}>
                        <CustomTable
                            cols={cols}
                            data={tableData}
                            isCheckbox={false}
                            actionComp={Action}
                            count={data?.result?.total || 0}
                            onPageChange={({ page, rows }) => {
                                setPage(page);
                                setLimit(rows);
                            }}
                        />
                    </Box>
                </Box>
            </Stack>

            {/* Confirmation Dialog */}
            <Dialog open={Boolean(confirmAction)} onClose={handleConfirmClose}>
                <DialogTitle>Confirm {confirmAction?.status === 'Approved' ? 'Accept' : 'Reject'}</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to {confirmAction?.status === 'Approved' ? 'accept' : 'reject'} this request?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: 2 }}>
                    <Button onClick={handleConfirmClose} variant="outlined">Cancel</Button>
                    <Button
                        onClick={handleConfirmProceed}
                        variant="contained"
                        color={confirmAction?.status === 'Rejected' ? 'error' : 'primary'}
                        autoFocus
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default RequestedInflyxCoins;
